import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "absolute left-[25%] h-full w-[1px] bg-white" }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "absolute left-[50%] h-full w-[1px] bg-[#6150FF]" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "absolute left-[75%] h-full w-[1px] bg-white" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    ref: "bar",
    class: "relative h-2 flex-1 cursor-pointer rounded-3xl bg-[rgba(255,255,255,0.3)]",
    onMousedown: _cache[0] || (_cache[0] = (e) => _ctx.slideFactory.startMove(e.clientX)),
    onTouchstart: _cache[1] || (_cache[1] = (e) => _ctx.slideFactory.startMove(e.touches[0].clientX))
  }, [
    _hoisted_1,
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", {
      class: "absolute top-[50%] h-6 w-6 translate-y-[-50%] rounded-3xl bg-[#6150ff]",
      style: _normalizeStyle({
        left: `calc(${_ctx.props.modelValue}% - 12px)`,
        boxShadow: '0px 4px 12px rgba(111, 164, 255, 0.3)',
      })
    }, null, 4)
  ], 544))
}